<template>
  <div>
    <div class="position-relative">
      <!-- ✅ Lazy load -->
      <img :src="assets.onlineRechargeBonus_banner" alt="" loading="lazy" />

      <div class="position-absolute start-0 end-0 mx-auto text-center rechargeBonusEvent-box">
        <div class="position-absolute top-n40 start-0 end-0 mx-auto w-100" style="max-width:280px;">
          <img :src="assets.rechargeBonusEventTitleBg" alt="" loading="lazy" />
          <h2 class="position-absolute start-0 end-0 w-100 my-0 fst-italic fw-900 BonusEvent-title">
            Recharge Bonus Event
          </h2>
        </div>

        <div class="flex-box justify-content-center fst-italic fw-900 mb-3 BonusEvent-subTitle">
          Get more
          <img :src="assets.diamondIcon" class="diamondIcon" alt="" loading="lazy" />
          for a limited time
        </div>

        <h1 class="flex-box justify-content-center fst-italic fw-900 bonusEvent-HD">
          During the event, use this coupon code and receive up to
          <span class="bonusPer-val">10%</span> extra diamonds
        </h1>

        <!-- Coupon Box -->
        <div class="position-relative fw-900 mx-auto discount-coponBox">
          <div class="position-absolute fst-italic discount-coponLeftBox">
            <div class="copon-val">10%</div>
            <div class="discountText">Discount</div>
          </div>
          <div class="position-absolute top-0 start-0 end-0 m-auto fst-italic discount-coponRightBox">
            {{ couponCode }}
          </div>
        </div>

        <!-- Copy Button -->
        <div
          class="d-flex justify-content-center align-items-center gap-1 cursor-pointer copyCode-note"
          @click="copyCoponCode"
        >
          Click here to copy code
          <img
            :src="assets.coponCodeCopyIcon"
            class="position-relative coponCode-copyIcon"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <!-- Copy Popup -->
    <div v-if="showCopyPopup" class="copy-popup">Coupon Code Copied</div>
  </div>
</template>

<script>
import "./OnlineRechargeBonus.css";
import onlineRechargeBonus_banner from "../../assets/images/onlineRechargeBonus/onlineRechargeBonus_banner.webp";
import rechargeBonusEventTitleBg from "../../assets/images/onlineRechargeBonus/rechargeBonusEventTitle-bg.webp";
import diamondIcon from "../../assets/images/diamond-icon.png";
import coponCodeCopyIcon from "../../assets/images/onlineRechargeBonus/coponCode-copyIcon.webp";

const assets = {
  onlineRechargeBonus_banner,
  rechargeBonusEventTitleBg,
  diamondIcon,
  coponCodeCopyIcon,
};

export default {
  name: "OnlineRechargeBonus",

  data() {
    return {
      assets,
      couponCode: "GETOFF10",
      showCopyPopup: false,
      popupTimer: null,
    };
  },

  beforeUnmount() {
    clearTimeout(this.popupTimer);
  },

  methods: {
    copyCoponCode() {
      const code = this.couponCode;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(code)
          .then(() => this.showPopup())
          .catch(() => this.fallbackCopy(code));
      } else {
        this.fallbackCopy(code);
      }
    },

    fallbackCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.showPopup();
    },

    showPopup() {
      this.showCopyPopup = true;

      clearTimeout(this.popupTimer);
      this.popupTimer = setTimeout(() => {
        this.showCopyPopup = false;
      }, 2000);
    },
  },
};
</script>
